import * as React from "react"
import type { SVGProps } from "react"
const SvgCircleFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M8.1 21.21A10 10 0 0 0 12 22a10 10 0 0 0 3.9-.79 10 10 0 0 0 3.18-2.14q1.34-1.34 2.13-3.17A10 10 0 0 0 22 12a10 10 0 0 0-.79-3.9 10 10 0 0 0-2.14-3.17 10 10 0 0 0-3.17-2.14A10 10 0 0 0 12 2a10 10 0 0 0-3.9.79 10 10 0 0 0-3.17 2.14Q3.56 6.28 2.78 8.1A10 10 0 0 0 2 12q0 2.07.79 3.9a10 10 0 0 0 2.14 3.18q1.35 1.34 3.17 2.13" />
  </svg>
)
export default SvgCircleFilled
